import React from "react";

const OptionalCell = () => {

    return (
        <div
            className="tw-flex tw-h-[80px] tw-p-3 tw-flex-col tw-justify-center tw-items-start tw-gap-2 tw-self-stretch tw-border-b tw-border-solid tw-border-mutelios-blue-light">
                            <span
                                className="tw-text-body-lead-bold tw-text-mutelios-txt-color">Renfort facultatif</span>
            <img src="/o/mutelios-theme-css/icons/RectangleOrange.svg" alt=""/>
        </div>
    );
}

export default OptionalCell;
